import React from 'react';
import { useApp } from '../../../context/AppContext';
import DashboardPage from './DashboardPage';
import PublisherDashboardPage from '../../publishers/PublisherDashboardPage';
import AdminDashboard from '../../admins/adminDashboard';
import TEODashboardPage from './TEODashboardPage';
import HeadMasterDashboardPage from '../../headmasters/HeadMasterDashboardPage';
import ProcurementDashboardPage from '../../procurement/ProcurementDashboardPage';
import MinisterDashboardPage from '../../executive/MinisterDashboardPage';

// Add more role-specific dashboards as needed

export default function DashboardRouter() {
  const { roles } = useApp();
  if (!roles || roles.length === 0) return <DashboardPage />;

  if (roles.includes('ROLE_SUPER_ADMIN')) return <AdminDashboard />;
  if (roles.includes('ROLE_ADMIN')) return <AdminDashboard />;
  if (roles.includes('ROLE_PUBLISHER')) return <PublisherDashboardPage />;
  if (roles.includes('ROLE_MINISTER')) return <MinisterDashboardPage />;
  if (roles.includes('ROLE_HEAD_MASTER')) return <HeadMasterDashboardPage />;
  if (roles.includes('ROLE_TO') || roles.includes('ROLE_TEO')) return <TEODashboardPage />;
  if (roles.includes('ROLE_PO') || roles.includes('ROLE_PEO') || roles.includes('ROLE_PROCUREMENT_OFFICER')) return <ProcurementDashboardPage />;
  // inventory roles
  if (roles.includes('ROLE_INVENTORY_ADMIN')) return <DashboardPage />; // placeholder
  if (roles.includes('ROLE_INVENTORY_USER')) return <DashboardPage />;

  return <DashboardPage />; // default fallback
}
